












































































































import {Component, Prop, Vue} from 'vue-property-decorator'

export type CDLanguageRatioItem = {
  language: string
  ratio: number
}

@Component({})
export default class CDTopLanguages extends Vue {
  @Prop({type: Array, default: () => []})
  items!: CDLanguageRatioItem[]

  /** Mobile layout: card with two columns (hidden on md+ at parent level). */
  @Prop({type: Boolean, default: false})
  cardLayout!: boolean

  get leftColumnItems(): CDLanguageRatioItem[] {
    const list = this.items || []
    const mid = Math.ceil(list.length / 2)
    return list.slice(0, mid)
  }

  get rightColumnItems(): CDLanguageRatioItem[] {
    const list = this.items || []
    const mid = Math.ceil(list.length / 2)
    return list.slice(mid)
  }
}
